<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-8">
          <strong class="card-title mb-3">P Analysis </strong> <span v-if="(selTab !== 'S1 S' || selTab !== 'p Trends')">Company count: {{rawData.length}}</span>
        </div>
        <div class="col-md-3" v-if="(selTab !== 'S1 S' && selTab !== 'Return Analysis') && tabs.length>0">
          <download :tableId="tabs[actTab]['title']" :fileName="tabs[actTab]['title']+'-data'"></download>
        </div>
        <div class="col-md-3" v-if="(selTab === 'S1 S')">
          <download :tableId="'s1s'" :fileName="'s1-s-data'"></download>
        </div>
        <div class="col-md-3" v-if="(selTab === 'Return Analysis')">
          <download :tableId="'return-analysis'" :fileName="'return-analysis-data'"></download>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <vue-tabs direction="horizontal" @tab-change="getTabData">
        <v-tab :title="alg.name" v-for="(alg, index) in tabs" v-bind:key="index">
          <div class="mb-15"></div>
          <pAnalysisData
            :title="alg.title"
            :pData="rawData"
            :mcFilter="mcOptions"
            :sectorList="sectors"
            :pfilterOptions="filterOptions"
            :pTableFields="tableFields"
            @filterD="filtData"
            @searchD="searchdata"
            @rangeFilt="rangeFilter"
            ref="panalysis"
          ></pAnalysisData>
        </v-tab>
         <v-tab :title="'Return Analysis'">
          <div class="mb-15"></div>
         <returnAnalysis
            :mcFilter="mcOptions"
            :sectorList="sectors"
            ref="s1sum"
          ></returnAnalysis>
        </v-tab>
         <v-tab :title="'S1 S'">
          <div class="mb-15"></div>
         <s1
            :mcFilter="mcOptions"
            :sectorList="sectors"
            ref="s1sum"
          ></s1>
        </v-tab>
        <v-tab :title="'p Trends'">
          <div class="mb-15"></div>
          <pTrends :isIndividual="1"></pTrends>
        </v-tab>
      </vue-tabs>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { pCommonMixins } from "../../assets/mixins/pcommon.js";
import pAnalysisData from "@/views/market-data/p-analysis-data";
import returnAnalysis from "@/views/market-data/return-analysis";
import s1 from "@/views/market-data/s1-s";
import pTrends from "@/views/company/pTrends";
export default {
  components: {
    pAnalysisData,
    pTrends,
    s1,
    returnAnalysis
  },
  mixins: [commonMixins, pCommonMixins],
  created() {
    if (
      this.tabs[this.actTab].title !== "return-analysis" &&
      this.tabs[this.actTab].title !== "p9_S"
    ) {
      // console.log("P TABS");
      this.minRange = ["", ""];
      this.maxRange = ["", ""];
      this.selFilter = ["market_capitalization", this.tabs[this.actTab].title];
    } else {
      this.minRange = "";
      this.maxRange = "";
      this.selFilter = "";
    }
    this.getPData();
    this.getSectorData();
  },
  data() {
    return {
      tabs: [
        { title: "p1_S", name: "P1 S", rawDataApi: "getPSumData" },
        { title: "p2_S", name: "P2 S", rawDataApi: "getPSumData" },
        { title: "p3_S", name: "P3 S", rawDataApi: "getPSumData" },
        { title: "p4_S", name: "P4 S", rawDataApi: "getPSumData" },
        { title: "p5_a_S", name: "P5 A S", rawDataApi: "getPSumData" },
        { title: "p5_b_S", name: "P5 B S", rawDataApi: "getPSumData" },
        { title: "p6_a", name: "P6 A S", rawDataApi: "getPSumData" },
        { title: "p6_b", name: "P6 B S", rawDataApi: "getPSumData" },
        { title: "p7_a_S", name: "P7 A S", rawDataApi: "getPSumData" },
        { title: "p7_b_S", name: "P7 B S", rawDataApi: "getPSumData" },
        { title: "p8_a_S", name: "P8 A S", rawDataApi: "getPSumData" },
        { title: "p8_b_S", name: "P8 B S", rawDataApi: "getPSumData" },
        { title: "p9_S", name: "P9 S", rawDataApi: "getP9SumData" },
        { title: "p10_S", name: "P10 S", rawDataApi: "getPSumData" },
        { title: "p11_S", name: "P11 S", rawDataApi: "getPSumData" },
        { title: "q1_S", name: "Q1 S", rawDataApi: "getPSumData" },
        { title: "q1_a_S", name: "Q1 A S", rawDataApi: "getPSumData" },
        { title: "q1_b_S", name: "Q1 B S", rawDataApi: "getPSumData" },
        { title: "q1_c_S", name: "Q1 C S", rawDataApi: "getPSumData" },
        { title: "q1_d_S", name: "Q1 D S", rawDataApi: "getPSumData" },
        { title: "q1_a_or_b", name: "Greater Q1 A/B", rawDataApi: "getPSumData" },
        { title: "quarterly_trends", name: "Quarterly Trends", rawDataApi: "getPSumData" },
        // {
        //   title: "return-analysis",
        //   name: "Return Analysis",
        //   rawDataApi: "getReturnAnalysis"
        // }
      ],
      selTab: null, //"p1_S",
      actTab: 0,
      mcOptions: [
        { id: 0, value: "All", min: "", max: "" },
        { id: 1, value: "MC > 20000", min: 20000, max: "" },
        { id: 2, value: "5000 <= MC <= 20000", min: 5000, max: 20000 },
        { id: 3, value: "1000 <= MC <= 5000", min: 1000, max: 5000 },
        { id: 4, value: "MC <= 1000", min: "", max: 1000 }
      ],
      rawData: [],
      searchData: [],
      sectors: [],
      minRange: "",
      maxRange: "",
      selFilter: "",
      sectorname: "",
      ddate: new Date().setDate(new Date().getDate() - 1), //"", //
      filterOptions: [
        {
          id: "",
          value: "Select",
          isNumeric: true,
          sort_order: 0
        }
      ],
      tableFields: [],
      rawDataApi: "getPSumData",
      isTabChanged: true
    };
  },
  methods: {
    getTabData(tabIndex, newTab, oldTab) {
      console.log(tabIndex, newTab.title, oldTab);
      this.selTab = newTab.title;
      this.actTab = tabIndex;
      if (tabIndex < 22) {
        this.actTab = tabIndex;
        this.rawDataApi = this.tabs[this.actTab].rawDataApi;
        if (this.tabs[this.actTab].title !== "p9_S") {
          // console.log("P TABS");
          this.minRange = ["", ""];
          this.maxRange = ["", ""];
          this.selFilter = [
            "market_capitalization",
            this.tabs[this.actTab].title
          ];
        } else {
          this.minRange = "";
          this.maxRange = "";
          this.selFilter = "";
        }
        this.sectorname = "";
        this.ddate = new Date().setDate(new Date().getDate() - 1);
        this.isTabChanged = true;
        this.filterOptions = [
          {
            id: "",
            value: "Select",
            isNumeric: true,
            sort_order: 0
          }
        ];
        this.getPData();
      }
    },
    getSectorData() {
      let _this = this;
      http.get("getSectorList", {}, function(error, response) {
        // console.log("Sector Data", response);
        _this.sectors = response;
      });
    },
    rangeFilter(e) {
      this.filterRangeData(e);
    },
    searchdata(e) {
      this.filteredList(e);
    }
  }

};
</script>
<style>
form .col-md-3 {
  width: 40%;
}

.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/market-data/p-analysis.vue